module.exports = __webpack_public_path__ + "img/email.7b79287d.svg";